/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalIdObjectRelationships =
  "/data_objects/:type_name/:external_id/object_relationships" as const;
